import { useEffect } from "react";
import {
  generatePath,
  Navigate,
  useNavigate,
  useParams,
} from "react-router-dom";

import { LoadingState } from "~/common/components";
import { PATIENT_STATUS } from "~/common/constants";
import {
  patientScreeningSectionTitle,
  SCREENING_STATUSES,
} from "~/common/utils/consultations/screening";
import { StartConsultationSection } from "~/patients/components/consultations";
import {
  useGetCurrentPatient,
  useGetScreening,
  useStartScreening,
} from "~/patients/hooks";
import { ROUTES } from "~/patients/router";

export const StartScreening = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: user } = useGetCurrentPatient();
  const consultationId = user?.consultation?.id;

  const providerImage =
    user?.organization_patients[0]?.primary_provider?.profile_picture_path;
  const userCanAccessScreening =
    !!id &&
    user?.organization_patients[0].status !== PATIENT_STATUS.active &&
    !!user?.organization_patients[0].email_verified_at;

  const { data: screeningData, isLoading } = useGetScreening(
    id,
    consultationId,
    userCanAccessScreening,
  );

  const { startScreeningMutation, isPending } = useStartScreening();

  const { status } = {
    ...screeningData,
  };

  const redirectToScreeningIfStarted = () => {
    if (status === SCREENING_STATUSES.in_progress && id) {
      navigate(
        generatePath(ROUTES.screening, {
          id,
        }),
      );
    }
    if (status === SCREENING_STATUSES.completed) {
      navigate(ROUTES.screeningAlreadyCompleted);
    }
  };

  useEffect(redirectToScreeningIfStarted, [redirectToScreeningIfStarted]);

  if (!userCanAccessScreening) return <Navigate to={ROUTES.notFound} />;

  if (isLoading || !screeningData)
    return <LoadingState className="h-screen-calculated" />;

  const { order, duration, code } = {
    ...screeningData,
  };

  return (
    <StartConsultationSection
      section={order}
      duration={duration}
      title={patientScreeningSectionTitle[code]}
      handleContinue={() => startScreeningMutation({ id, consultationId })}
      handleGoBack={() => navigate(ROUTES.leadPatientHome)}
      pendingContinue={isPending}
      providerImageSrc={providerImage}
    />
  );
};
